var map = {
	"./de/general7/slide4.svg": 822385,
	"./en/general7/slide4.svg": 795917,
	"./es/general7/slide4.svg": 414244,
	"./fr/general7/slide4.svg": 206172,
	"./nl/general7/slide4.svg": 659674,
	"./pt/general7/slide4.svg": 747272
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 395969;